export default "__VITE_ASSET__be121989__"